"use client"

import { klaviyoFormCodesMap } from "@/app/(site)/_components/Modules/Checkout/Views/Information/maps"
import { t } from "@/translations"

export interface ProductUspsProps {
    usps: { text: string; addKlaviyoButton: boolean }[]
    langCode: string
}

export const ProductUsps = ({ usps, langCode }: ProductUspsProps) => {
    const triggerKlaviyoEmailForm = (
        e: React.MouseEvent<HTMLButtonElement>,
        langCode: string
    ) => {
        e.preventDefault()

        window._klOnsite = window._klOnsite || []

        const formCode =
            klaviyoFormCodesMap.get(langCode) || klaviyoFormCodesMap.get("en")
        window._klOnsite.push(["openForm", formCode])
    }

    if (!Array.isArray(usps) || usps.length === 0) return null

    return (
        <ol className="flex list-none flex-col gap-y-3">
            {usps.map(({ text, addKlaviyoButton }) => (
                <li
                    key={text}
                    className="text-col-text-primary Trade_Gothic_Text_12_150_0_300"
                >
                    - {text}
                    {addKlaviyoButton && (
                        <button
                            onClick={e => triggerKlaviyoEmailForm(e, langCode)}
                            className="ml-4 text-col-text-primary underline"
                        >
                            {t(langCode, "footer.newsletter_sign_up")}
                        </button>
                    )}
                </li>
            ))}
        </ol>
    )
}
